"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
class DataChangeEvent {
    constructor() {
        this.Timestamp = new Date();
    }
}
exports.DataChangeEvent = DataChangeEvent;
